import { SortDescriptor } from "@progress/kendo-data-query";

export class Campaign {
  campaignId: string = '';
  name: string = '';
  status: string = '';
  type: string = '';
  state: string = '';
  startDate: Date = new Date();
  endDate: Date = new Date();
  orders: number = 0;
  sales: number = 0;
  spend: number = 0;
  avgDailySpent: number = 0;
  createdAt: string | Date = new Date();
  updatedAt: string | Date = new Date();
  budget: number = 0;
  suggestBudget: number = 0;
  budgetType: string = '';
  inventoryStatus: string = '';
  skuCount: number = 0;
  logCount: number = 0;

  constructor(init?: Partial<Campaign>) {
    if (init) {
      // if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}

export interface IFilterItemsByCampaign {
  skip: number;
  take: number;
  filter: any;
  sort: SortDescriptor[];
}
